import React from "react";
import { Link } from "react-router-dom";

// Small decorative ornament (diamond quatrefoil style)
export const Ornament = ({ size = 12, color = "#b08a4a" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M12 1 L15 9 L23 12 L15 15 L12 23 L9 15 L1 12 L9 9 Z" fill={color} opacity="0.95" />
    <circle cx="12" cy="12" r="1.4" fill="#f5f1ea" />
  </svg>
);

const Logo = ({ large = false }) => (
  <Link to="/" className={`logo ${large ? "logo-lg" : ""}`} aria-label="Label Binduu Jain Couture">
    <span className="logo-top">LABEL</span>
    <span className="logo-main">BINDUU JAIN</span>
    <span className="logo-ornament"><Ornament size={large ? 14 : 11} /></span>
    <span className="logo-sub">COUTURE</span>
  </Link>
);

export default Logo;


